export default __webpack_public_path__ + "static/media/tagihan-overdue.5658ea47.svg";